enum WorkspaceProjectCertificationAiAdviserPromptFeedback {
  helpful = 'helpful',
  not_helpful = 'not_helpful',
}

export default WorkspaceProjectCertificationAiAdviserPromptFeedback
